import { render, staticRenderFns } from "./write-duration.vue?vue&type=template&id=0a0a0ab6&"
import script from "./write-duration.vue?vue&type=script&lang=js&"
export * from "./write-duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports